import { transition } from '@helpers/animate';
import { imageCoverContainer, imageWrapperPreserveRatio } from '@helpers/aspectRatio';
import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import { contentStyles, h5, paragraphSmall } from '@helpers/typography';
import ButtonStyles from '@stories/Components/Buttons/Button/Button.styles';
import CategoryTagsStyles from '@stories/Components/Misc/CategoryTags/CategoryTags.styles';
import styled from 'styled-components';
const Container = styled.a `
  --borderRadius: ${fluid(16, 24)};
  --paddingX: ${fluid(16, 24)};
  --paddingY: ${fluid(24, 32)};

  display: flex;
  flex-direction: column;
  text-decoration: none;
  border-radius: var(--borderRadius);
  background: linear-gradient(180deg, #3372aa 40%, #1e2f6d 100%);
`;
const Image = styled.img `
  ${imageCoverContainer()};

  border-radius: var(--borderRadius) var(--borderRadius) 0 0;
`;
const ImageWrapper = styled.span `
  ${imageWrapperPreserveRatio(504, 280)};

  &:has(${Image})::before {
    ${transition('opacity')};

    content: '';
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(
      180deg,
      rgba(36, 36, 39, 0.25) 0%,
      rgba(36, 36, 39, 0.32) 45%,
      rgba(36, 36, 39, 0.92) 100%
    );
    mix-blend-mode: multiply;
    z-index: 1;
    border-radius: var(--borderRadius) var(--borderRadius) 0 0;

    ${Container}:focus-visible &,
    ${Container}:hover & {
      opacity: 0.85;
    }
  }

  ${CategoryTagsStyles.Container} {
    position: absolute;
    top: var(--paddingX);
    left: var(--paddingX);
    width: calc(100% - var(--paddingX) * 2);
    z-index: 2;
  }
`;
const CompanyLogo = styled.img `
  position: absolute;
  bottom: var(--paddingX);
  left: var(--paddingX);
  max-width: ${fluid(94, 142)};
  max-height: ${fluid(42, 64)};
  z-index: 2;
`;
const ContentWrapper = styled.span `
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: var(--paddingY) var(--paddingX);
  color: ${brand.primary.white};

  border-radius: 0 0 var(--borderRadius) var(--borderRadius);

  ${ButtonStyles.Container} {
    margin-top: auto;
  }
`;
const Title = styled.span `
  ${h5};

  margin-bottom: ${fluid(8, 16)};
`;
const Summary = styled.span `
  ${contentStyles};

  margin-bottom: ${fluid(24, 40)};

  /* --bulletColour: ${brand.tertiary.sun}; */

  p,
  li {
    ${paragraphSmall};
  }

  ul:not([style*='list-style-type']) li::before {
    top: ${fluid(5, 7.5)};
  }

  ol,
  ul {
    margin-top: ${fluid(14, 20)};
    margin-bottom: ${fluid(14, 20)};
  }
`;
const MarketplaceCardStyles = {
    Container,
    ImageWrapper,
    Image,
    ContentWrapper,
    CompanyLogo,
    Title,
    Summary,
};
export default MarketplaceCardStyles;
